import type { Conference } from "../../api.js";
import { ReviewWorkspace } from "../review/ReviewWorkspace.js";

export function ReviewStage({ conference }: { conference: Conference }) { return <ReviewWorkspace conference={conference} />; }
